import { Viewer, Worker } from "@react-pdf-viewer/core";
import { useState } from "react";
// import { pdfjs } from 'react-pdf';
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/LocalPrintshopSharp";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
export default function CommonPDFViewer({
  pdfFile,
  isDownload = false,
  isPrint = true,
  downloadFileName = null,
  PageWidthFull = true,
  handleDirectPrint,
}) {
  const [hasError, setHasError] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {(slots) => {
          const {
            CurrentPageLabel,
            Download,
            GoToNextPage,
            GoToPreviousPage,
            Print,
            Zoom,
            ZoomIn,
            ZoomOut,
          } = slots;

          return (
            <div
              className={` flex justify-between w-full px-2 items-center gap-5 ${
                !downloadFileName ? "pl-7" : "pl-2"
              }`}
            >
              <div
                className={isDownload && "cursor-pointer"}
                style={{ padding: "0px 2px", marginLeft: "auto" }}
              >
                {isDownload && (
                  <Download>
                    {(props) => (
                      <button
                        type="button"
                        onClick={(e) => {
                          if (downloadFileName !== null) {
                            const fileName =
                              downloadFileName &&
                              downloadFileName.endsWith(".pdf")
                                ? downloadFileName
                                : `${downloadFileName}.pdf`;
                            const anchor = document.createElement("a");
                            anchor.href = pdfFile;
                            anchor.download = fileName;
                            anchor.click();
                          } else {
                            props.onClick();
                          }
                        }}
                      >
                        <DownloadIcon color="action" />
                      </button>
                    )}
                  </Download>
                )}
              </div>
              <div
                className={isPrint && "cursor-pointer"}
                style={{ padding: "0px 2px" }}
              >
                {isPrint && (
                  <Print>
                    {(props) => (
                      <button
                        type="button"
                        onClick={() => {
                          if (handleDirectPrint) {
                            handleDirectPrint();
                          } else {
                            props.onClick();
                          }
                        }}
                      >
                        <PrintIcon color="action" />
                      </button>
                    )}
                  </Print>
                )}
              </div>
            </div>
          );
        }}
      </Toolbar>
    ),
    sidebarTabs: () => [],
  });
  const handleDocumentLoad = (e) => {
    setHasError(false);
    // setInitialLoadComplete(true);
    const { activateTab } = defaultLayoutPluginInstance;
    if (activateTab) {
      activateTab(0);
    }
  };

  const renderError = (error) => {
    setHasError(true);
    let message = "";
    switch (error.name) {
      case "InvalidPDFException":
        message = "The document is invalid or corrupted";
        break;
      case "MissingPDFException":
        message = "The document is missing";
        break;
      case "UnexpectedResponseException":
        message = "Unexpected server response";
        break;
      default:
        message = "Cannot load the document";
        break;
    }

    return (
      <div className="flex justify-center items-center h-full">
        <div className="bg-[#e53e3e] rounded text-white p-2">{message}</div>
      </div>
    );
  };

  const renderLoader = () => (
    <div className="flex justify-center items-center h-full">
      <div className="text-gray-600">Loading PDF...</div>
    </div>
  );
  const preventRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <div onContextMenu={preventRightClick} style={{ userSelect: "none" }}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer
          fileUrl={pdfFile}
          plugins={[defaultLayoutPluginInstance]}
          onDocumentLoad={handleDocumentLoad}
          renderError={renderError}
          renderLoader={renderLoader}
          theme="light"
          // defaultScale={SpecialZoomLevel.PageWidth}
          // defaultScale={PageWidthFull ? SpecialZoomLevel.PageWidth : SpecialZoomLevel.PageFit}
        />
      </Worker>
    </div>
  );
}
